import React from "react"
import styles from "./CalculadoraDeMaterialesSkeleton.module.scss"

const CalculadoraDeMaterialesSkeleton = () => {
  return (
    <div className={styles.skeleton}>
      <div className={styles.skeleton_header}>
        <div className={styles.skeleton_header_title}>
          <div className={styles.skeleton_line} style={{ width: "60%", height: "2.2rem" }} />
          <div className={styles.skeleton_line} style={{ width: "85%", height: "1.6rem" }} />
        </div>
        <div className={styles.skeleton_header_button}>
          <div className={styles.skeleton_btn} />
        </div>
      </div>
      <div className={styles.skeleton_bodyContainer}>
        <div className={styles.skeleton_bodyColumn}>
          <div className={styles.skeleton_body_header}>
            <div className={styles.skeleton_search} />
            <div className={styles.skeleton_dropdown} />
          </div>
          <div className={styles.skeleton_body_card}>
            <div className={styles.skeleton_body_content}>
              <div className={styles.skeleton_body_line} />
              <div className={styles.skeleton_body_line} />
              <div className={styles.skeleton_body_line} style={{ width: "70%" }} />
            </div>
          </div>
        </div>
        <div className={styles.skeleton_summaryColumn}>
          <div className={styles.skeleton_summary_header}>
            <div className={styles.skeleton_line} style={{ width: "60%", height: "1.8rem" }} />
            <div className={styles.skeleton_icon} />
          </div>
          <div className={styles.skeleton_summary_card}>
            <div className={styles.skeleton_summary_content}>
              <div className={styles.skeleton_summary_item} />
              <div className={styles.skeleton_summary_item} />
              <div className={styles.skeleton_summary_item} style={{ width: "80%" }} />
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

export default CalculadoraDeMaterialesSkeleton
